import React from 'react';

const Somos = () => {
  return (
    <div id="nosotros" className="mt-10 min-h-screen bg-slate-900 flex flex-col items-center justify-center text-white px-4">
      {/* Título principal */}
      <h1 className="text-5xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-600">
        Bienvenido a <br /> Invision
      </h1>

      {/* Descripción de la fundación */}
      <p className="text-lg text-purple-300 text-center max-w-2xl mb-8">
        Somos un proyecto dedicado a hacer accesible el conocimiento para personas ciegas y con discapacidad visual. A través de audiolibros, tecnologías innovadoras y recursos digitales, buscamos eliminar barreras y abrir las puertas del aprendizaje a todos.
      </p>

      {/* Misión y Visión */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
        {/* Misión */}
        <div className="bg-slate-800 p-6 rounded-xl border border-purple-400/30 hover:border-purple-400/60 transition-all duration-300">
          <h2 className="text-2xl font-semibold text-purple-400 mb-4">Nuestra Misión</h2>
          <p className="text-purple-200">
            Brindar acceso igualitario al conocimiento mediante recursos adaptados para personas ciegas y con discapacidad visual, promoviendo la inclusión y el empoderamiento.
          </p>
        </div>

        {/* Visión */}
        <div className="bg-slate-800 p-6 rounded-xl border border-purple-400/30 hover:border-purple-400/60 transition-all duration-300">
          <h2 className="text-2xl font-semibold text-purple-400 mb-4">Nuestra Visión</h2>
          <p className="text-purple-200">
            Un mundo donde todas las personas, sin importar sus capacidades visuales, puedan acceder libremente al conocimiento y disfrutar de las historias que transforman vidas.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Somos;